import api from './api';

class DeviseService {
  async getAllDevises(params = {}) {
     const response = await api.get('/devises', { params });
    return response.data;
  }

  async getDevise(id) {
     const response = await api.get(`/devises/${id}`);
    console.log('Client data:', response);
    return response.data;
  }

  async createDevise(deviseData) {
    const response = await api.post('/devises', deviseData);
    return response.data;
  }

  async updateDevise(id, deviseData)  {
    const response = await api.put(`/devises/${id}`, deviseData);
    return response.data;
  }

  async deleteDevise(id) {
    const response = await api.delete(`/devises/${id}`);
    return response.data;
  }

  async searchDevises(query){
      const response = await api.get('/devises/search', {
        params: { q: query }
      });
      return response.data;
  }
}

export default new DeviseService();